import { render } from "./ZoneVehicleData.vue?vue&type=template&id=64745ab6&ts=true"
import script from "./ZoneVehicleData.ts?vue&type=script&lang=ts"
export * from "./ZoneVehicleData.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__